import { AqSpecies } from '@app/feature/species/aq-species.model';
import { FoodSpecies } from '@app/feature/species/food-species.model';
import { Condition } from '@app/feature/condition';
import { ReportType } from './report-type';
import Big from 'big.js';
import { CURRENCY_ROUNDING_MODE, multiplyBig } from '@app/util/currency';

/**
 * Purchase.
 *
 * @author Warlock, AIS.PL
 */
export class Purchase {

  readonly foodSpecies: FoodSpecies;

  readonly aqSpecies: AqSpecies;

  readonly condition: Condition;

  readonly lbsBought: number;

  readonly piecesBought: number;

  pricePerLb: number;

  pricePerPc: number;

  readonly value: number;

  readonly speciesDisplayName: string;

  /**
   * Converts JSON representation of amendment into {@link Amendment} instance.
   *
   * @param jsonObject JSON representation of purchase report
   */
  static fromJSON(jsonObject: any): Purchase {
    const result = Object.create(Purchase.prototype);
    return Object.assign(result, jsonObject, {
      lbsBought: jsonObject.lbsBought ? Number(jsonObject.lbsBought) : null,
      piecesBought: jsonObject.piecesBought ? Number(jsonObject.piecesBought) : null,
      pricePerLb: jsonObject.pricePerLb ? Number(jsonObject.pricePerLb) : null,
      pricePerPc: jsonObject.pricePerPc ? Number(jsonObject.pricePerPc) : null,
      value: jsonObject.value ? Number(jsonObject.value) : null,
      speciesDisplayName: Purchase.createDisplayNameOfSpecies(jsonObject),
    });
  }

  static createDisplayNameOfSpecies(jsonObject: any) {
    const species = jsonObject.foodSpecies || jsonObject.aqSpecies;

    return species.localNames ? `${species.name} (${species.localNames})` : species.name;
  }

  public calculateTotal(reportType: ReportType): Big {
    if (this.isLbsBased(reportType)) {
      return multiplyBig(this.lbsBought, this.pricePerLb).round(2, CURRENCY_ROUNDING_MODE);
    } else {
      return multiplyBig(this.piecesBought, this.pricePerPc).round(2, CURRENCY_ROUNDING_MODE);
    }
  }

  public isLbsBased(reportType: ReportType): boolean {
    const species = this.foodSpecies || this.aqSpecies;
    return (ReportType.P === reportType) && !(species && species.lbsExempt);
  }

  public isPcsBased(reportType: ReportType): boolean {
    const species = this.foodSpecies || this.aqSpecies;
    return (ReportType.PAQ === reportType) || (species && species.lbsExempt);
  }

}
